import {
  getOrphanQuestionRecoveryMode,
  getOrphanQuestionRecoverySections,
  moveOrphanQuestionsToSection
} from './sectionCompatibility'
import { DEFAULT_SECTION_DIALOG_MODES } from '../dialogState'

function getNextOrphanQuestionRecoveryState({
  items = [],
  scoringType = null,
  source = 'checklist',
  translate = ({ number }) => `Section ${number}`,
  previousItems = items,
  isConditionalLogicEnabled = false,
} = {}) {
  if (scoringType !== 'section') {
    return null
  }

  const recoveryMode = getOrphanQuestionRecoveryMode(items, {
    isConditionalLogicEnabled,
  })
  if (recoveryMode === 'none') {
    return null
  }

  if (recoveryMode === 'create') {
    return {
      type: 'defaultSectionDialog',
      payload: {
        availableSections: [],
        existingSectionName: '',
        forceDefaultSectionDialog: false,
        items,
        mode: DEFAULT_SECTION_DIALOG_MODES.CREATE,
        previousItems,
        scoringType,
        source,
      },
    }
  }

  return {
    type: 'defaultSectionDialog',
    payload: {
      availableSections: getOrphanQuestionRecoverySections({
        items,
        getFallbackSectionLabel: translate,
        isConditionalLogicEnabled,
      }),
      existingSectionName: '',
      items,
      mode: DEFAULT_SECTION_DIALOG_MODES.MOVE_TO_SECTION_OR_CREATE,
      previousItems,
      scoringType,
      source,
    },
  }
}

function getOrphanQuestionRecoveryRequestState({
  items = [],
  scoringType = null,
  source = 'checklist',
  translate = ({ number }) => `Section ${number}`,
  isConditionalLogicEnabled = false,
} = {}) {
  return getNextOrphanQuestionRecoveryState({
    items,
    scoringType,
    source,
    translate,
    isConditionalLogicEnabled,
    previousItems: [],
  })
}

function getMovedOrphanQuestionRecoveryResult({
  items = [],
  scoringType = null,
  targetSectionId = null,
} = {}) {
  return {
    items: moveOrphanQuestionsToSection(items, targetSectionId),
    scoringType,
  }
}

function getCancelledOrphanQuestionRecoveryResult({
  previousItems = [],
  scoringType = null,
  source = 'checklist',
} = {}) {
  return {
    items: previousItems,
    returnToChecklist: source === 'scoring',
    scoringType,
  }
}

export {
  getOrphanQuestionRecoveryRequestState,
  getNextOrphanQuestionRecoveryState,
  getMovedOrphanQuestionRecoveryResult,
  getCancelledOrphanQuestionRecoveryResult
}
